import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy',
  template: `
  <h2>Legal Statements</h2>
  <h3>Privacy</h3>
  <h3>Commercial Confidentiality</h3>
  `
})
export class PrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
